// extracted by mini-css-extract-plugin
export default {"portfolioWrapper":"PortfolioLayout_portfolioWrapper__L31YX"};